import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import CloseButton from "common/CloseButton"
import { useState } from "react"
import styled from "styled-components"
import ContactForm from "./ContactForm"

const StyledContainer = styled.div`
  position: relative;
  text-align: center;
  padding: 20px;
  width: 100%;

  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 470px;
    padding: 20px 60px;
  }
`
const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 30px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`

type ContactDialogProps = {
  open: boolean
  onClose: () => void
}

const ContactDialog = ({ open, onClose }: ContactDialogProps) => {
  const [response, setResponse] = useState<boolean | null>(null)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-label="טופס חזרה טלפונית"
      TransitionProps={{ onExited: () => setResponse(null) }}
    >
      <StyledContainer>
        <CloseButton onClick={onClose} />

        {response === null && <DialogTitle>טופס חזרה טלפונית</DialogTitle>}

        <DialogContent>
          {response === null ? (
            <ContactForm onSubmit={setResponse} />
          ) : response ? (
            <Typography variant="h2">הטופס נשלח בהצלחה!</Typography>
          ) : (
            <>
              <Typography variant="h2">שליחת הטופס נכשלה</Typography>
              <StyledButton
                variant="contained"
                color="primary"
                onClick={() => setResponse(null)}
              >
                נסיון נוסף
              </StyledButton>
            </>
          )}
        </DialogContent>
      </StyledContainer>
    </Dialog>
  )
}

export default ContactDialog
